import { Internal } from '../internal';
import { Entity } from './entities.model';
import { PaginationParams, SortParams } from './helpers.model';

export type ListType = 'long-list' | 'short-list';

export const VacancyBidStatus = {
  long_list: {
    name: 'Long List',
    sort: 0,
  },
  ai: {
    name: 'AI',
    sort: 1,
  },
  unresolved: {
    name: 'Applies',
    sort: 2,
  },
  request_avail: {
    name: 'Analyzing profile',
    sort: 3,
  },
  send_cv: {
    name: 'Sent to Reviewer',
    sort: 4,
  },
  arrange_interview: {
    name: 'Interview planed',
    sort: 5,
  },
  confirm: {
    name: 'Hired',
    sort: 6,
  },
  not_appropriate: {
    name: 'Not appropriate',
    sort: 7,
  },
};
export enum VacancyBidSource {
  ai = 'Ai',
  apec = 'Apec',
  ask_ubuntu = 'Ask Ubuntu',
  amazing_huring = 'Amazing Huring',
  angel_co = 'Angel.co',
  cv_parsing = 'CV Parsing',
  dou = 'DOU',
  dribble = 'Dribble',
  extension = 'Extension',
  elance = 'Elance',
  facebook = 'Facebook',
  github = 'GitHub',
  github_lite = 'Github SC',
  djinni = 'Djinni',
  gitlab = 'GitLab',
  green_house = 'Green House',
  head_hunter = 'HeadHunter',
  import = 'Import',
  linkedin = 'LinkedIn',
  linkedin_google = 'LinkedIn Google',
  linkedin_lite = 'Linkedin SC',
  my_talents = 'My Talents',
  moi_krug = 'Moi Krug',
  merge_talents = 'Merge Talents',
  manually = 'Manually',
  public_talents = 'Public Talents',
  profile_page = 'Profile Page',
  personal_assistant = 'Personal Assistant',
  pole_emploi = 'Pôle emploi',
  project_source = 'Project Source',
  rabota_ua = 'Rabota.Ua',
  robota_apply = 'Rabota.Ua Apply',
  robota_search = 'Rabota.Ua Search',
  stackoverflow = 'StackOverflow',
  stackoverflow_lite = 'StackOverflow SC',
  sendgrid = 'Sendgrid',
  turbohiring = 'TurboHiring',
  twitter = 'Twitter',
  upwork = 'Upwork',
  vk_com = 'vk.com',
  xing = 'Xing',
  work_ua = 'Work.Ua',
  work_apply = 'Work.Ua Apply',
  work_search = 'Work.Ua Search',
  recruiter_lite = 'Recruiter Lite',
  sales_navigator = 'Sales Navigator',
}
export type VacancyBidStatuses = keyof typeof VacancyBidStatus;
export type VacancyBidSources = keyof typeof VacancyBidSource;

export interface VacanciesList {
  items: Internal.Vacancy.Response.Item;
  totalCount: number;
}
export interface IncludedItem extends Entity {
  name: string;
  count: number;
  code?: 'string';
}
export interface ProfilesIncluded {
  authors: IncludedItem[];
  rejectReasons: IncludedItem[];
  statuses: IncludedItem[];
  sources: IncludedItem[];
}

export interface VacancyNonMappedBidStatusEvent extends Entity {
  author: Internal.Recruiter.User.Base;
  source: Internal.Dictionary.Generic.Source;
  statuses: number[];
}

export interface VacancyMappedBidStatistic {
  [key: number]: { [name in VacancyBidSources]?: number };
}

export interface VacancyActivities {
  apply_to_vacancy?: number;
  bidStatusMovement: VacancyMappedBidStatistic;
  bid_status_movement: VacancyNonMappedBidStatusEvent[];
  rejected_bids: { name: string; count: string }[];
  long_list_count: number;
  long_list_dates: string[];
  open_profiles_in_right_panel_total: number;
  plugin_view: { [name in VacancyBidSources]: number } | [];
  try_apply_to_vacancy?: number;
  view_profiles_in_search:
    | {
        candidates?: number;
        githubSmart?: number;
        linkedinSmart?: number;
        profiles?: number;
        stackoverflowSmart?: number;
        turbohiring?: number;
      }
    | [];
  view_profiles_in_search_total: number;
}

export interface VacancySuggestedParams {
  city: number[] | null;
  duration: number | null;
  level: number | null;
  mainSkill: number[] | null;
  skills: number[] | null;
  speciality: number[] | null;
  type: number | null;
}
export interface NotificationProfile extends Entity {
  author: {
    firstName: string;
    lastName: string;
    imageThumbnail: string;
  };
  clicks: number;
  lastClickedAt?: string;
  lastOpenedAt?: string;
  opens: number;
  status: string;
  recipient: {
    firstName: string;
    imageThumbnail?: string;
    lastName: string;
    developer: Entity & {
      color: string;
    };
  };
}

export const VacancyExportFields = [
  'title',
  'created_at',
  'success_closed_date',
  'unsuccess_closed_date',
  'client_name',
  'client_team',
  'assigned_recruiter',
  'speciality',
  'main_skill',
  'hired',
  'not_accepted',
  'notified',
  'cv_sent_date',
  'company_name',
  'interview_date',
  'ling_list',
  'applies',
  'processing',
  'applied_at',
  'last_comment',
  'status',
];
export const VacancyCandidatesExportFields = [
  'first_name',
  'last_name',
  'email',
  'phone',
  'authors',
  'source',
  'main_skill',
  'skills',
  'tags',
  'created_at',
  'comment',
  'social_links',
  'created_at',
  'description',
  'inside_information',
  'project_title',
  'bid_status_name',
  'bid_status_changed_at',
  'bid_reject_reason',
];

export interface VacancyStatistic {
  rejections?: Record<string, number>;
  authors: Record<string, number>;
  candidatesCount: number;
  statuses: Record<string, { [key: string]: number }>;
  sources: Record<string, number>;
}

export interface VacancyExportRequest
  extends Partial<PaginationParams>, Partial<SortParams> {
  clients?: number[];
  createdFrom?: string | null;
  createdTo?: string | null;
  fields: string[];
  emails?: string[];
  format: string;
  keyword?: string[];
  recruiters?: number[];
  statuses?: number[];
  type?: number;
}
export type VacancyExportType = 'project' | 'profile_project' | 'profile';

export const enum VacanciesListQuickFilters {
  ANY,
  MY_ACTIVE,
  MY,
  ALL_ACTIVE,
}

export interface VacancySuggestionsResponse {
  readonly city: number[];
  readonly duration: number;
  readonly level: number;
  readonly mainSkill: number[];
  readonly skills: number[];
  readonly speciality: number[];
}
